var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#abb3ba",
  d: "M14.222 0H1.778C.79 0 0 .771 0 1.714v12c0 .943.791 1.715 1.778 1.715h3.555L8 18l2.667-2.571h3.555c.978 0 1.778-.772 1.778-1.715v-12C16 .771 15.2 0 14.222 0M8 2.829c1.324 0 2.4 1.037 2.4 2.314S9.324 7.457 8 7.457 5.6 6.42 5.6 5.143 6.676 2.829 8 2.829M13.333 12H2.667v-.771C2.667 9.514 6.222 8.57 8 8.57s5.333.943 5.333 2.658z"
})));
export default SvgUser;